// removed by extract-text-webpack-plugin
module.exports = {"photosesh-type":"_2FJ34CzGqFP1yXoUQ22PAD","ant-card":"_1jTNyohs4LsF6UQV1pwcYS","container":"_3M-SIRVAWy5OA_vPdT99g6","custom-image":"_1RPvADN3juMVMeGuwjA7dN","custom-card":"_37Y6fMyBV1fX3eyOakekM8","price":"_1sNhK85l6BFDPzekwmejtB","custom-detail-light":"_3-fMGoeAPMw1WodkffIQEc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/photosesh_type.css
// module id = 3019
// module chunks = 0